import { Chip } from "@mui/material"
import CodeIcon from '@mui/icons-material/Code';
import TagRoundedIcon from '@mui/icons-material/TagRounded';

export const COLUMNSDIVISIONESAGESTIONAR = [
    {
        header: 'Código Materia',
        accessorKey: 'new_codigomateria',
        Cell: ({ cell }) => <Chip icon={<TagRoundedIcon />} label={cell.getValue()} variant="outlined" color="secondary" />
    },
    {
        header: 'Materia',
        accessorKey: 'new_materia',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Período',
        accessorKey: '_new_periodo_value',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Modalidad',
        accessorKey: 'new_modalidaddictado',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    // {
    //     header: 'Sede',
    //     accessorKey: 'new_seccion',
    //     Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    // },
    {
        header: 'Division',
        accessorKey: 'new_name',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Tipo de División',
        accessorKey: 'new_tipodedivision',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Estado',
        accessorKey: 'statuscode',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    // {
    //     header: 'Aceptación',
    //     accessorKey: 'new_seccion',
    //     Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    // },

]

export const COLUMNSACTIVIDADESAGESTIONAR = [
    {
        header: 'Período',
        accessorKey: 'new_periodo',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Actividad',
        accessorKey: 'act_new_name',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Código Materia',
        accessorKey: 'new_codigomateria',
        Cell: ({ cell }) => <Chip icon={<TagRoundedIcon />} label={cell.getValue()} variant="outlined" color="secondary" />
    },
    {
        header: 'Materia',
        accessorKey: 'new_materia',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Carrera',
        accessorKey: 'new_carreras',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Área disciplinar',
        accessorKey: 'new_areadisciplinar',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Estado',
        accessorKey: 'statuscode',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },

]


export const COLUMNSPLANIFICACIONESNO = [
    {
        header: 'Docente',
        accessorKey: 'new_docente',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Código materia',
        accessorKey: 'new_codigomateria',
        Cell: ({ cell }) => <Chip icon={<TagRoundedIcon />} label={cell.getValue()} variant="outlined" color="secondary" />
    },
    {
        header: 'Materia',
        accessorKey: 'new_materia',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Matriz',
        accessorKey: 'new_matriz',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Período',
        accessorKey: 'new_periodo',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Estado',
        accessorKey: 'statuscode',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
]

export const COLUMNSPLANIFICACIONES = [
    {
        header: 'Docente',
        accessorKey: 'new_docente',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Materia',
        accessorKey: 'new_materia',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Matriz',
        accessorKey: 'new_matriz',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Período',
        accessorKey: 'new_periodo',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Estado',
        accessorKey: 'statuscode',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
]

export const COLUMNSHORARIOS = [
    {
        header: 'Días de dictado',
        accessorKey: 'new_dia',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Hora inicio',
        accessorKey: 'new_horainicio',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Hora fin',
        accessorKey: 'new_horafin',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Fecha de dictado',
        accessorKey: 'new_fecha',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Aula',
        accessorKey: 'new_aula',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
]

export const COLUMNSFECHAFINAL = [
    {
        header: 'Fecha de examen',
        accessorKey: 'new_fechayhora',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Llamado',
        accessorKey: 'new_llamadoaexamen',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
]

export const COLUMNSFECHAPARCIAL = [
    {
        header: 'Materia',
        accessorKey: 'new_materia',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Clase de parcial',
        accessorKey: 'new_clasedeparcial',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Fecha de examen',
        accessorKey: 'new_fechayhorainicio',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
]

export const COLUMNSFORMACION = [
    {
        header: 'Formación',
        accessorKey: 'new_name',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Tipo de formación',
        accessorKey: 'new_tipodeformacion',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Tipo de experiencia',
        accessorKey: 'cr879_tipodeexperienciadeaprendizaje',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
]

export const COLUMNSTAREAS = [
    {
        header: 'Materia',
        accessorKey: 'new_materia',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Asunto',
        accessorKey: 'subject',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Fecha de inicio',
        accessorKey: 'scheduledstart',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Fecha de finalización',
        accessorKey: 'scheduledend',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
]

export const COLUMNSPI = [
    {
        header: 'Titulo',
        accessorKey: 'new_name',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Materia',
        accessorKey: 'new_materia',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Matriz',
        accessorKey: 'new_matriz',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'División',
        accessorKey: 'new_division',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Fecha de inicio',
        accessorKey: 'new_fechadeinicio',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Fecha de finalización',
        accessorKey: 'new_fechadefinalizacin',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Estado',
        accessorKey: 'statuscode',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
]

export const COLUMNSPAT = [
    {
        header: 'Nombre',
        accessorKey: 'new_name',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Materia',
        accessorKey: 'new_materia',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'División',
        accessorKey: 'new_division',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Matriz',
        accessorKey: 'new_matriz',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Modalidad',
        accessorKey: 'new_modalidad',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Sede',
        accessorKey: 'new_sede',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
]

export const COLUMNSPIC = [
    {
        header: 'Nombre',
        accessorKey: 'new_name',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Materia',
        accessorKey: 'new_materia',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'División',
        accessorKey: 'new_division',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Matriz',
        accessorKey: 'new_matriz',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Fecha',
        accessorKey: 'createdon',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
]

{/* <Chip icon={<FaceIcon />} label="With Icon" variant="outlined" /> */}